import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/BrowserPolyfills.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/ClientPageFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/ClientPageHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/DataDogInitClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/MicroFrontendClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/ScrollRestoration.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/SpaNavigationListener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/GoogleTagManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalLayoutProvider"] */ "/home/vsts/work/1/s/merch-ui/src/context/common/GlobalLayoutContext.tsx");
